module.exports = __webpack_public_path__ + "static/img/water2.13bb4e1.png";